import { Link } from "react-router-dom";
import { MapPin, Briefcase, Clock, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function JobCard({ job, testIdPrefix = "job-card" }) {
  const exp = job.experience_min === job.experience_max
    ? `${job.experience_min} yrs`
    : `${job.experience_min}-${job.experience_max} yrs`;
  return (
    <Link
      to={`/jobs/${job.slug}`}
      data-testid={`${testIdPrefix}-${job.slug}`}
      className="group relative block overflow-hidden rounded-xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg"
    >
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          {job.department && (
            <div className="overline mb-2">
              {job.department}
              {job.sub_department && <span className="ml-1 text-slate-400"> · {job.sub_department}</span>}
            </div>
          )}
          <h3 className="font-heading text-xl font-semibold text-slate-900 group-hover:text-primary">
            {job.title}
          </h3>
        </div>
        <span className="shrink-0 whitespace-nowrap rounded-full bg-secondary/10 px-3 py-1 text-xs font-semibold text-secondary">
          {job.employment_type}
        </span>
      </div>
      <p className="line-clamp-2 text-sm leading-relaxed text-slate-600">
        {job.description}
      </p>

      <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-slate-600">
        <span className="inline-flex items-center gap-1.5"><MapPin className="h-4 w-4 text-primary" />{job.location}</span>
        <span className="inline-flex items-center gap-1.5"><Briefcase className="h-4 w-4 text-primary" />{exp}</span>
        {job.salary_range && (
          <span className="inline-flex items-center gap-1.5"><Clock className="h-4 w-4 text-primary" />{job.salary_range}</span>
        )}
      </div>

      {job.skills?.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-2">
          {job.skills.slice(0, 4).map((s) => (
            <Badge key={s} variant="secondary" className="bg-slate-100 text-slate-700 hover:bg-slate-100">{s}</Badge>
          ))}
        </div>
      )}

      <div className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-primary">
        View role <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
